import { useSelector } from "react-redux";
import useAffinityGroupColumns from "./Hooks/useAffinityGroupColumns";
import {
  setAffinityGroupData,
  setAgFilterForm,
  setAgSorting,
} from "../../../slices/ag/affinityGroup/affinityGroupSlice";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import {
  btnAccessChecker,
  checkButtonAccess,
} from "../../../Utils/CommonUtils";
import AffinityGroupFilter from "./AffinityGroupFilter";
import { resetFormState } from "../../../slices/common/reducer";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const AffinityGroupList = () => {
  const dispatch = useDispatch();
  const { affinityGroupColumns } = useAffinityGroupColumns();

  const affinityGroupData = useSelector(
    (state) => state.affinityGroup.affinityGroupData
  );
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const selector = useSelector((state) => state.moduleaccesstree);

  const filterApi = useSelector(
    (state) => state.affinityGroup.filter.filterApi
  );
  const filterForm = useSelector((state) => state.affinityGroup.filter.form);
  const sortColumn = useSelector((state) => state.affinityGroup.sorting.column);
  const sortOrder = useSelector((state) => state.affinityGroup.sorting.order);
  const enterpriseid = localStorage.getItem("enterpriseid");
  const userid = localStorage.getItem("userId");

  useEffect(() => {
    dispatch(resetFormState());
    dispatch(setAgFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        title={"All PSP"}
        // newButton={btnAccessChecker("SETT_UMT_ROL", "CREATE", selector) && true}
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "AG_AG")}
        formLink="/ag/ag/create"
        deletebtn={true}
        buttonTitle={"New AG"}
        filterComponent={<AffinityGroupFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={affinityGroupColumns}
          data={affinityGroupData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"AGRP"}
          filterApiListEntity={"AGRP"}
          filterApiFunction={setAffinityGroupData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setAgSorting}
          enterpriseId={enterpriseid}
          userId={userid}
          organizationType="AG"
        />
      </div>
    </div>
  );
};

export default AffinityGroupList;
